import { Link, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";

type EventContactInfoProps = {
  eventUrl: string;
  handleWindowOpen: (url: string, trackWithPostHog: boolean) => void;
  eventPhone: string;
  eventEmail: string;
};

export const EventContactInfo = ({
  eventUrl,
  handleWindowOpen,
  eventPhone,
  eventEmail,
}: EventContactInfoProps) => {
  const { t } = useTranslation("events", { keyPrefix: "WIDGET" });

  return (
    <Flex part="details__contact-info-container" flexDir="column" gap="200">
      <Text part="details__contact-info-title" visual="smallLabel">
        {t("LABELS.CONTACT")}
      </Text>
      <Flex flexDir="column" gap="75" alignItems="flex-start">
        {eventUrl && (
          <Link
            part="details__contact-info-link"
            href={eventUrl}
            onClick={() => handleWindowOpen(eventUrl, true)}
            target="_blank"
            rel="noopener noreferrer"
            color="text.mid"
            size="sm"
            lineClamp={1}
            wordBreak="break-all"
            _hover={{
              textDecoration: "underline",
            }}
          >
            {eventUrl}
          </Link>
        )}
        {eventPhone && (
          <Link
            part="details__contact-info-link"
            href={`tel:${eventPhone}`}
            target="_blank"
            rel="noopener noreferrer"
            color="text.mid"
            size="sm"
            lineClamp={1}
            wordBreak="break-all"
            _hover={{
              textDecoration: "underline",
            }}
          >
            {eventPhone}
          </Link>
        )}
        {eventEmail && (
          <Link
            part="details__contact-info-link"
            href={`mailto:${eventEmail}`}
            target="_blank"
            rel="noopener noreferrer"
            color="text.mid"
            size="sm"
            lineClamp={1}
            wordBreak="break-all"
            _hover={{
              textDecoration: "underline",
            }}
          >
            {eventEmail}
          </Link>
        )}
      </Flex>
    </Flex>
  );
};
